var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ComposerAnalyticsEvent, ComposerMode, } from '../types/index';
/**
 * The single EDIT save sequence: declines → PATCH → optional /move →
 * analytics → onSubmit → onClose. All three save entry points (the plain
 * Update path, UpdateRecurringEventModal, ConfirmSpaceMoveModal) run this;
 * they differ only in the options they pass and in how they clean up their
 * own state per outcome.
 *
 * The move runs LAST — on O365 it copies the (already updated) event to the
 * new space and cancels the old one, so nothing may target the event after
 * it. A move failure leaves the edits saved; the composer stays open so
 * Update can retry (declines are guarded, the PATCH is idempotent).
 */
export function performEventSave(deps, payload, eventId, options) {
    return __awaiter(this, void 0, void 0, function () {
        var declinesSucceeded, response, _a, meta, moveResult;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, deps.declineRemovedSpaces()];
                case 1:
                    declinesSucceeded = _f.sent();
                    if (!declinesSucceeded) {
                        return [2 /*return*/, 'declines_failed'];
                    }
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, deps.updateEvent(payload, eventId, options.seriesOption, deps.updateAsSpace, (_b = options.recurrenceChanged) !== null && _b !== void 0 ? _b : false, deps.hasReservationApproval)];
                case 3:
                    response = _f.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = _f.sent();
                    // updateEvent set editEventError; the ErrorModal owns retry.
                    (_c = deps.onTrackComposerEvent) === null || _c === void 0 ? void 0 : _c.call(deps, ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                        mode: ComposerMode.EDIT,
                    });
                    return [2 /*return*/, 'update_failed'];
                case 5:
                    if (!response) {
                        // updateEvent resolves undefined ONLY when the request was aborted
                        // (the composer is closing) — a real failure sets editEventError and
                        // throws. Nothing to toast, track, or close.
                        return [2 /*return*/, 'aborted'];
                    }
                    if (!options.move) return [3 /*break*/, 7];
                    return [4 /*yield*/, deps.moveEvent({
                            eventId: eventId,
                            oldSpaceId: options.move.fromSpace.id,
                            newSpaceId: options.move.toSpace.id,
                            startTime: payload.startTime,
                            endTime: payload.endTime,
                            timezone: payload.timezone,
                            notifyAttendees: options.notifyAttendees,
                        })];
                case 6:
                    moveResult = _f.sent();
                    if (moveResult === 'aborted') {
                        // Composer closed mid-flight; the move's outcome is indeterminate
                        // and there is no one left to notify.
                        return [2 /*return*/, 'aborted'];
                    }
                    if (moveResult === 'failed') {
                        // The edits are saved but the event stays in the old room — the one
                        // half-applied state in the sequence, so it gets telemetry.
                        (_d = deps.onTrackComposerEvent) === null || _d === void 0 ? void 0 : _d.call(deps, ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                            mode: ComposerMode.EDIT,
                            step: 'move',
                        });
                        deps.onError(new Error(deps.t('errors.event_saved_room_not_changed', {
                            name: options.move.toSpace.name,
                        })));
                        return [2 /*return*/, 'move_failed'];
                    }
                    meta = {
                        organizerMove: {
                            fromSpaceId: options.move.fromSpace.id,
                            toSpaceId: options.move.toSpace.id,
                        },
                    };
                    _f.label = 7;
                case 7:
                    (_e = deps.onTrackComposerEvent) === null || _e === void 0 ? void 0 : _e.call(deps, ComposerAnalyticsEvent.EVENT_UPDATED, __assign({ updatedAsSpace: deps.updateAsSpace }, options.analytics));
                    deps.onSubmit(response.data, ComposerMode.EDIT, meta);
                    deps.onClose();
                    return [2 /*return*/, 'saved'];
            }
        });
    });
}
